import React from "react";

export default function SingleUserCard(props) {

  const confirmDeletingUser = () => {
    const confirmation = window.confirm("Are you sure you want to delete it?");
    if(confirmation === true){
      props.deleteHandler(props.userEmail);
    } else {
      return;
    }
  }

  return (
    <div className="single-user-card p-0 mb-sm-0 mb-2 main-card-cover">
      {/* User Account Details (Profile Img, name and email start) */}
      <div className="accountDetails d-flex justify-content-start align-items-center">
        {/* Image */}
        <img
          src={props.userImg}
          alt="user-profile-pic"
          className="testimonial-user-profile-pic"
        />
        {/* Details */}
        <div className="details">
          <p className="p-0 m-0 name fw-medium text-capitalize">{props.userFirstName} {props.userLastName}</p>
          <p className="p-0 m-0 role">{props.userEmail}</p>
        </div>
      </div>
      {/* User Account Details (Profile Img, name and email End) */}

      <hr className="accountDetails-hr" />

      {/* User Details Start */}
      <div className="userDetails">
        <p className="mb-2">
          <span className="details-title">Mob Number:&nbsp;&nbsp;</span>
          <span>{props.userMobile}</span>
        </p>
        <p className="mb-2">
          <span className="details-title">Password:&nbsp;&nbsp;</span>
          <span>{props.userPassword}</span>
        </p>
        <p className="mb-2">
          <span className="details-title">Home Address:&nbsp;&nbsp;</span>
          <span className="text-capitalize">{props.userAddress}</span>
        </p>
      </div>
      {/* User Details End */}

       {/* Update and Delete Button */}
       <div className="update-delete-btns">
          <button className="del-btn btn" onClick={confirmDeletingUser}>
            <i className="fa-solid fa-trash"></i>
          </button>
        </div>
    </div>
  );
}
